import { Link } from "react-router-dom";
import InfoPage, { InfoSection } from "@/components/InfoPage";
import { COMPANY, LOYALTY } from "@/data/site";

const Terms = () => (
  <InfoPage
    eyebrow="Terms of Service"
    title="Terms of Service."
    intro={`These terms govern your use of this website and any purchase you make from ${COMPANY.legalName} ("DNA", "we", "us"). By using the site or placing an order, you agree to them.`}
    updated="October 2026"
    testId="terms-page"
  >
    <InfoSection heading="1. Your account">
      <p>You need an account to place an order. Keep your login details private — you are responsible for activity on your account. Tell us straight away if you think it has been misused.</p>
    </InfoSection>

    <InfoSection heading="2. Products and information">
      <p>We work hard to describe our products accurately, including nutrition values and ingredients. Packaging may change slightly between batches; the label on the product you receive is the final reference.</p>
      <p>Our products are foods, not medicines. They are not intended to diagnose, treat, cure or prevent any disease. If you are pregnant, nursing, on medication or have a medical condition, consult a doctor before use. Check the ingredient list for allergens — our bars contain nuts and milk.</p>
    </InfoSection>

    <InfoSection heading="3. Prices and payment">
      <p>All prices are in Indian Rupees and include applicable taxes. Payments are processed securely by Razorpay; we never see or store your card details. An order is confirmed only once payment succeeds.</p>
      <p>We may change prices at any time, but the price you pay is the one shown when you place the order.</p>
    </InfoSection>

    <InfoSection heading="4. Subscriptions">
      <p>Monthly boxes renew each month at the subscription price shown at checkout. You can pause or cancel any time before your next renewal by writing to {COMPANY.email}.</p>
    </InfoSection>

    <InfoSection heading="5. Loyalty points">
      <p>
        Paid orders earn loyalty points that can be redeemed against future orders, up to{" "}
        {Math.round(LOYALTY.maxRedeemShare * 100)}% of an order's value. Points have no cash value, cannot be
        transferred, and are withdrawn if the order that earned them is cancelled. We may change or end the programme
        with reasonable notice.
      </p>
    </InfoSection>

    <InfoSection heading="6. Shipping, returns and refunds">
      <p>
        Delivery, cancellation, return and refund terms are set out in{" "}
        <Link to="/our-policies" className="text-[#C07C5F] underline underline-offset-4">Our Policies</Link> and form
        part of these terms.
      </p>
    </InfoSection>

    <InfoSection heading="7. Use of the site">
      <p>Do not misuse the site — including attempting to access it in unauthorised ways, interfering with its operation, or reselling our products without written permission. All content, branding and imagery on this site belong to DNA.</p>
    </InfoSection>

    <InfoSection heading="8. Liability">
      <p>To the extent permitted by law, our total liability for any claim relating to an order is limited to the amount you paid for that order. Nothing in these terms limits rights you have under the Consumer Protection Act, 2019.</p>
    </InfoSection>

    <InfoSection heading="9. Governing law">
      <p>These terms are governed by the laws of India. Courts in Gurugram, Haryana have exclusive jurisdiction.</p>
    </InfoSection>

    <InfoSection heading="10. Contact">
      <p>{COMPANY.legalName}, {COMPANY.address.join(" ")} — {COMPANY.email}</p>
    </InfoSection>
  </InfoPage>
);

export default Terms;
